const errors = {
	NOT_FOUND: 'NOT_FOUND',
	SERVER_ERROR: 'SERVER_ERROR',
	NETWORK_ERROR: 'NETWORK_ERROR',
}

export default errors



// WEBPACK FOOTER //
// ./client/errors/index.js